import React from "react"

export default function Security() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_8_284)">
        <path d="M20.2292 5.26921L12.7279 2.14421C12.4994 2.04944 12.2544 2.00066 12.007 2.00066C11.7596 2.00066 11.5147 2.04944 11.2862 2.14421L3.78485 5.26921C3.0855 5.55828 2.62839 6.24187 2.62839 6.99968C2.62839 14.7536 7.10185 20.113 11.2823 21.8552C11.7433 22.0466 12.2629 22.0466 12.724 21.8552C16.0722 20.4606 21.3818 15.6442 21.3818 6.99968C21.3818 6.24187 20.9247 5.55828 20.2292 5.26921ZM12.009 19.4333L12.0051 4.55046L18.8774 7.41374C18.7485 13.3278 15.6698 17.613 12.009 19.4333V19.4333Z" fill="#5B5E71" />
      </g>
      <defs>
        <clipPath id="clip0_8_284">
          <rect width="20" height="20" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  )
}